import './ArtistPage.scss';
import ArtistPageContent from "./ArtistPageContent";
import ArtistPageContext from './ArtistPageContext';
import ArtistPageLoader from "./ArtistPageLoader";

export default function ArtistPage() {
  return (
    <ArtistPageLoader>
      { ({ artist }) => (
        <ArtistPageContext artist={ artist }>
          <ArtistPageContent />
        </ArtistPageContext>
      ) }
    </ArtistPageLoader>
  );
}
